
import Vue from "vue";

export default Vue.extend({
    name: "SuccessMessage",
    props: ["msg"],
});
